import { Loader } from '@karma/components';
import { useEffect, useState } from 'react';
import { Body } from './ModalBodyLoyaltyForm.style';

const ModalBodyLoyaltyForm = () => {
  const [isLoaderShown, setIsLoaderShown] = useState(true);

  useEffect(() => {
    const timerId = setTimeout(setIsLoaderShown, 2000, false);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <Body>
      <div
        className="hs-form-frame"
        data-region="na1"
        data-form-id="691bd183-df37-43a5-a79b-64ceb1d1be64"
        data-portal-id="6989004"
      />
      {isLoaderShown && <Loader className="loader" absolute />}
    </Body>
  );
};

export default ModalBodyLoyaltyForm;
